import forEach from '../_helpers/foreach.js';
// converts Matreshka.Array instance to ordinary array
export default function toJSON(recursive) {
  if (recursive === void 0) {
    recursive = true;
  }
  var result = new Array(this.length);
  forEach(this, function (item, index) {
    // when recursive is true and when an item has toJSON method then call it recusively
    if (recursive && item && typeof item.toJSON === 'function') {
      result[index] = item.toJSON(true);
    } else {
      result[index] = item;
    }
  });
  return result;
}